import { ActionIcon } from '@mantine/core'
import { IconTrash } from '@tabler/icons-react'
import { Employee } from '@viterbit/web-app/dataAccess/model/Employee.model'
import EmployeeItem from '@viterbit/web-app/feature/employee/item/EmployeeItem'
import * as React from 'react'

type TeamLeaderItemProps = {
    className?: string
    item: Employee
    onDeleteItem?: (e: React.MouseEvent) => void
}

const TeamLeaderItem = ({
    className = '',
    item,
    onDeleteItem
}: TeamLeaderItemProps) => (
    <div className={`p-3 border border-gray-300 flex justify-between items-center rounded-md shadow-sm ${className} bg-white`}>
        <EmployeeItem className='truncate' employee={item}/>

        <ActionIcon onClick={onDeleteItem}>
            <IconTrash size={20} />
        </ActionIcon>
    </div>
)

export default TeamLeaderItem
